import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import { Tabs as TabsMUI } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/styles';
import TabButton from './TabButton';
const styles = (theme) => createStyles({
    tabsWrapperIndicator: {
        display: 'none',
    },
});
const TabsButtonsBar = (props) => {
    const { classes, tabIndex, buttons, handleTabButtonClick, textColor = 'primary', width = '100%', variant = 'fullWidth', children, theme, setTabIndex, innerRef, testId = 'TabsButtonsBar', ...other } = props;
    const tabButtons = buttons.map((btn, index) => (React.createElement(TabButton, { "data-testid": `TabButton-${btn.key}`, onClick: (e) => handleTabButtonClick(index, btn.key, e), key: btn.key, text: btn.label })));
    return (React.createElement(TabsMUI, Object.assign({ classes: { indicator: classes.tabsWrapperIndicator }, value: tabIndex, textColor: textColor, style: { width }, variant: variant }, other), tabButtons));
};
const ComposedTabsButton = compose(withStyles(styles, { withTheme: true }), pure, withHandlers({
    handleTabButtonClick: ({ setTabIndex, tabIndex }) => (index, buttonName, e) => {
        if (tabIndex === index) {
            e.preventDefault();
            return;
        }
        return setTabIndex(index, buttonName);
    },
}))(TabsButtonsBar);
ComposedTabsButton.displayName = 'TabsButton';
export default ComposedTabsButton;
//# sourceMappingURL=TabsButtonsBar.js.map